import { Directive } from "@angular/core";

@Directive({selector: "[mainContainerSideNav]"})
export class EmcMainContainerSideNavDirective {
}
